var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isReady
    ? _c("aside", { staticClass: "c-upgradableSubscription" }, [
        _c("div", { staticClass: "l-container" }, [
          _c("div", { staticClass: "c-upgradableSubscription_title" }, [
            _c("h1", { staticClass: "c-upgradableSubscription_title_h1" }, [
              _vm._v(
                "\n                " +
                  _vm._s(this.companyName) +
                  " pode ter mais visibilidade com o plano " +
                  _vm._s(this.requirements.eligiblePlan) +
                  "!\n            "
              ),
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "c-upgradableSubscription_closeIcon",
              attrs: {
                src: require("icon/custom/modal-close-white.svg"),
                alt: "fechar",
                title: "fechar",
              },
              on: {
                click: function ($event) {
                  return _vm.postToggleUpgradableBanner()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-upgradableSubscription_incentive" }, [
            _c(
              "div",
              { staticClass: "c-upgradableSubscription_incentive_image" },
              [
                _c("img", {
                  attrs: {
                    src: require("icon/custom/increasing-laptop.svg"),
                    alt: "Imagem",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-upgradableSubscription_incentive_title" },
              [
                _c("h2", [
                  _vm._v(
                    "Conheça os benefícios do plano " +
                      _vm._s(this.requirements.eligiblePlan) +
                      ":"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-listSquare" }, [
                  _c("li", { staticClass: "m-listSquare_item" }, [
                    _vm._v(_vm._s(this.requirements.visibilityBenefit)),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "m-listSquare_item" }, [
                    _vm._v(_vm._s(this.requirements.priorityBenefit)),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "m-listSquare_item" }, [
                    _vm._v(_vm._s(this.requirements.creditBenefit)),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-upgradableSubscription_incentive_button" },
              [
                _c(
                  "a",
                  {
                    attrs: { href: this.getCheckoutUrl },
                    on: {
                      click: function ($event) {
                        return _vm.postToggleUpgradableBanner()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.buttonSubscriptionPlan))]
                ),
              ]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }